export default {
  APP: ['app'], //Subject to change based on initGmi pathConfig
  FETCHING: {
    CDA: ['gmi', 'fetching', 'cda'],
    CDA_SERVICES: ['gmi', 'fetching', 'cda_services'],
    GMA: ['gmi', 'fetching', 'gma'],
    GMA_SERVICES: ['gmi', 'fetching', 'gma_services'],
    SOLR: ['gmi', 'fetching', 'solr'],
    SOLR_SERVICES: ['gmi', 'fetching', 'solr_services']
  },
  CDA: {
    SESSION: {
      CURRENT_PATH: ['gmi', 'cda', 'session', 'current'],
      CURRENT: {
        CDA_PATH: ['gmi', 'cda', 'session', 'current', 'cda'],
        CDA: {
          PROFILE: ['gmi', 'cda', 'session', 'current', 'cda', 'profile']
        },
        DEEM_PATH: ['gmi', 'cda', 'session', 'current', 'deem'],
        DEEM: {
          BOOKING: ['gmi', 'cda', 'session', 'current', 'deem', 'booking']
        }
      }
    },
    RESERVATION: {
      AIRLINE_LIST: ['gmi', 'cda', 'reservation', 'airline_list']
    }
  },
  DATA: {
    FILTERS: ['gmi', 'data', 'filters']
  },
  UI: {
    CAR_AND_DRIVER: {
      INITIATE_PATH: ['gmi', 'ui', 'car_and_driver', 'initiate'],
      INITIATE: {
        PICKUP: {
          PICKUP_DATE_TIME: ['gmi', 'ui', 'car_and_driver', 'initiate', 'pickup', 'pickup_date_time'],
          LOCATION: ['gmi', 'ui', 'car_and_driver', 'initiate', 'pickup', 'location']
        },
        EXTRA_STOPS: ['gmi', 'ui', 'car_and_driver', 'initiate', 'extra_stops'],
        PASSENGERS: ['gmi', 'ui', 'car_and_driver', 'initiate', 'number_of_passengers'],
        REQUESTED_DURATION: ['gmi', 'ui', 'car_and_driver', 'initiate', 'requested_duration'],
        BOOKING_TYPE: ['gmi', 'ui', 'car_and_driver', 'initiate', 'booking_type']
      },
      TRAVELER_INFORMATION: {
        BOOKER: ['gmi', 'ui', 'car_and_driver', 'traveler_information', 'booker'],
        PASSENGER: ['gmi', 'ui', 'car_and_driver', 'traveler_information', 'passenger']
      }
    },
    FILTERS: ['gmi', 'ui', 'filters'],
    PROFILE: {
      COMMUNICATION_PREFERENCES: {
        CONSENTS: ['gmi', 'ui', 'profile', 'communication_preferences', 'individual', 'consents'],
        PATH: ['gmi', 'ui', 'profile', 'communication_preferences'],
        PROFILE: ['gmi', 'ui', 'profile', 'communication_preferences', 'profile'],
        SUBSCRIPTIONS: ['gmi', 'ui', 'profile', 'communication_preferences', 'individual', 'subscriptions']
      }
    },
    RESERVATIONS: {
      CAR_CLASS: ['gmi', 'ui', 'reservations', 'car_class'],
      REDEMPTION_DAY_COUNT: ['gmi', 'ui', 'reservations', 'car_class', 'redemption_day_count'],
      COMMIT: ['gmi', 'ui', 'reservations', 'commit'],
      DRIVER_PROFILE: ['gmi', 'ui', 'reservations', 'driver_profile'],
      EXTRAS: ['gmi', 'ui', 'reservations', 'extras'],
      INITIATE: ['gmi', 'ui', 'reservations', 'initiate']
    },
    REWARDS: {
      HISTORY_PATH: ['gmi', 'ui', 'rewards', 'history'],
      HISTORY: {
        PAGE_NUMBER: ['gmi', 'ui', 'rewards', 'history', 'page_number'],
        START_DATE: ['gmi', 'ui', 'rewards', 'history', 'start_date'],
        END_DATE: ['gmi', 'ui', 'rewards', 'history', 'end_date']
      }
    },
    ID_VERIFY: {
      SDK_LOADING: ['gmi', 'ui', 'id_verify', 'sdk_loading'],
      SDK_INITIALIZED: ['gmi', 'ui', 'id_verify', 'sdk_initialized']
    },
    GOOGLE_MAPS: {
      API_LOADED: ['gmi', 'ui', 'google_maps', 'api_loaded'],
      LIBRARIES: ['gmi', 'ui', 'google_maps', 'libraries']
    },
    RENTAL_TICKET: {
      INITIATE: ['gmi', 'ui', 'rentalTicket', 'initiate'],
      DATE_TIME: ['gmi', 'ui', 'rentalTicket', 'initiate', 'return_location', 'date_time'],
    }
  },
  GMA: {
    CONTENT: {
      PARTNER_REWARD_PROGRAMS_SURCHARGE: ['gmi', 'gma', 'content', 'partner_reward_programs_surcharge'],
      PRIVACY: ['gmi', 'gma', 'content', 'privacy'],
      SUPPORT: {
        CONTACT: ['gmi', 'gma', 'content', 'support', 'contact']
      },
      TAXES: ['gmi', 'gma', 'content', 'taxes'],
      TERMS: {
        LOYALTY: ['gmi', 'gma', 'content', 'terms', 'loyalty'],
        PREPAY: ['gmi', 'gma', 'content', 'terms', 'prepay']
      },
      TERMS_OF_USE: ['gmi', 'gma', 'content', 'terms_of_use']
    },
    CONTRACT: {
      DETAILS: ['gmi', 'gma', 'contract', 'details']
    },
    COUPON: {
      DETAILS: ['gmi', 'gma', 'coupon', 'details']
    },
    LOCATION: {
      BY_ID: ['gmi', 'gma', 'location', 'by_id'],
      COUNTRIES: ['gmi', 'gma', 'location', 'countries'],
      STATES_OR_PROVINCES: ['gmi', 'gma', 'location', 'states_or_provinces'],
      BRANCH_POLICIES: ['gmi', 'gma', 'location', 'branch_policies']
    },
    REFERENCE: {
      PARTNER_REWARDS: ['gmi', 'gma', 'reference', 'partner_rewards'],
      SECURITY_QUESTIONS: ['gmi', 'gma', 'reference', 'security_questions']
    },
    RESERVATION: {
      CAR_CLASS_DETAILS: ['gmi', 'gma', 'reservation', 'car_class_details'],
      CARD_SUBMISSION_SESSION: ['gmi', 'gma', 'reservation', 'card_submission_session'],
      RENTAL_TERMS: ['gmi', 'gma', 'reservation', 'rental_terms'],
      PAYMENT: ['gmi', 'gma', 'reservation', 'payment']
    },
    REWARDS: {
      // note: we do not store HISTORY here as it needs custom data models in ui.rewards.history
      REWARDS_PATH: ['gmi', 'gma', 'rewards'],
      RETRO_CLAIM: ['gmi', 'gma', 'rewards', 'retro_claim'],
      TRANSFER_POINTS: ['gmi', 'gma', 'rewards', 'transfer_points'],
      TRANSACTION_HISTORY: ['gmi', 'gma', 'rewards', 'transaction_history']
    },
    TRIPS: {
      CURRENT: ['gmi', 'gma', 'trips', 'current'],
      INVOICE: ['gmi', 'gma', 'trips', 'invoice'],
      PAST: ['gmi', 'gma', 'trips', 'past'],
      RETRIEVE: ['gmi', 'gma', 'trips', 'retrieve'],
      UPCOMING: ['gmi', 'gma', 'trips', 'upcoming']
    },
    VEHICLES: {
      BY_COUNTRY: ['gmi', 'gma', 'vehicles', 'by_country'],
      CATEGORIES: {
        BY_COUNTRIES: ['gmi', 'gma', 'vehicles', 'categories', 'by_countries'],
        BY_COUNTRY: ['gmi', 'gma', 'vehicles', 'categories', 'by_country']
      }
    },
    ONLINE_CHECK_IN_PROFILE: ['gmi', 'gma', 'online_check_in_profile'],
    TICKET: {
      TICKET_TERMS_AND_CONDITIONS: ['gmi', 'gma', 'ticket', 'terms_and_conditions'],
      TICKET_PAYMENT_INITIATE: ['gmi', 'gma', 'ticket', 'payment', 'ibm_data'],
      TICKET_PAYMENT_CARD_DETAILS: ['gmi', 'gma', 'ticket', 'payment', 'card_details']
    },
    SUBSCRIPTION: {
      DETAILS: ['gmi', 'gma', 'subscription', 'details']
    },
    EXTEND_RENTAL: {
      ELIGIBILITY: ['gmi', 'gma', 'extend_rental', 'eligibility'],
      INITIATE: ['gmi', 'gma', 'extend_rental', 'initiate'],
      COMMIT: ['gmi', 'gma', 'extend_rental', 'commit']
    },
    EMERALD_CHECKOUT: {
      INITIATE: ['gmi', 'gma', 'emerald_checkout', 'initiate'],
      COMMIT: ['gmi', 'gma', 'emerald_checkout', 'commit'],
      VEHICLES: {
        BY_SESSION_ID: ['gmi', 'gma', 'emerald_checkout', 'vehicles', 'by_session_id']
      }
    }
  },
  MESSAGES: {
    CDA: ['gmi', 'messages', 'cda'],
    CDA_SERVICES: ['gmi', 'messages', 'cda_services'],
    GMA: ['gmi', 'messages', 'gma'],
    GMA_SERVICES: ['gmi', 'messages', 'gma_services'],
    SOLR: ['gmi', 'messages', 'solr'],
    SOLR_SERVICES: ['gmi', 'messages', 'solr_services']
  },
  SESSION: ['gmi', 'session'], //Subject to change based on initGmi pathConfig
  SOLR: {
    ALL: ['gmi', 'solr', 'all'],
    COUNTRY: ['gmi', 'solr', 'country'],
    COUNTRY_STATE: ['gmi', 'solr', 'country_state'],
    HOURS: ['gmi', 'solr', 'hours'],
    RENTER_AGE: ['gmi', 'solr', 'renter_age'],
    SPATIAL: ['gmi', 'solr', 'spatial'],
    TEXT: ['gmi', 'solr', 'text'],
    METHOD_OF_DELIVERY: ['gmi', 'solr', 'method_of_delivery']
  }
};
